import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"text-align":"right","margin-bottom":"10px"} }
const _hoisted_2 = { style: {"margin-left":"10px"} }

import { unref, reactive, ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage, ElMessageBox } from 'element-plus';

import { GbTables } from '@/components/GbTables';
import { useGbTable } from '@/hooks/useGbTable';

// 添加多语言支持
import { useLocales } from '@/hooks/useLocales';
import { useDictionary } from '@/store/dictionary.store';
import { findIndex, formatTools } from '@/utils';
import { Session } from '@/utils/storage';
import { config } from '@/config/config';
import { GetMaterialListApi } from '@/apis/contract/contract.draft.api';
import { DelMaterialsApi } from '@/apis/materials/material.api';
import PdfViewDialog from './pdfViewDialog.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const { t } = useLocales();

const pdfViewRef = ref<InstanceType<typeof PdfViewDialog>>();

const dicStore = useDictionary();
const { register, tableObject } = useGbTable();
const { fDateTime } = formatTools();
const { base_url } = config;
const { resolve, getRoutes } = useRouter();

const tabColumns = reactive<any[]>([
	{ field: 'file_name', label: t('billMaterialList.table.fileName', '文件名称') },
	{ field: 'material_type_desc', label: t('billMaterialList.table.category', '分类'), columnWidth: '100', align: 'center' },
	{ field: 'file_suffix', label: t('billMaterialList.table.fileType', '文件类型'), columnWidth: '80', headerAlign: 'center', align: 'center' },
	{ field: 'file_size', label: t('billMaterialList.table.fileSize', '文件大小'), columnWidth: '120', headerAlign: 'center', align: 'right' },
	{ field: 'curr_version', label: t('billMaterialList.table.currentVersion', '当前版本'), columnWidth: '80', align: 'center' },
	{ field: 'created_user_id', label: t('billMaterialList.table.uploadUser', '上传用户'), columnWidth: '120', align: 'center' },
	{ field: 'created_time', label: t('billMaterialList.table.uploadTime', '上传时间'), columnWidth: '120', align: 'center' },
	{ field: 'action', width: '180px', label: t('billMaterialList.table.action', '操作'), fixed: 'right', align: 'center' },
]);

const state = reactive({
	load: false,
	materialTypeList: [] as any[],
});

const actions = {
	showEdit: (row: any) => {
		if (row && row.file_suffix) {
			return ['.doc', '.docx', 'text', '.xls', 'xlsx'].indexOf(row.file_suffix) > 0;
		} else {
			return false;
		}
	},
	/* 文件预览 */
	preview: (row: any) => {
		/* .pdf文件避免使用OnlyOffice打开，因为pdf文件有可能引发不可预料的错误 */
		if (row.file_suffix != '.pdf') {
			/* 如果是office系文件，则使用onlyoffice打开 */
			const isOfficeFile = ['.doc', '.docx', 'text', '.xls', 'xlsx'].indexOf(row.file_suffix) > 0;
			if (isOfficeFile) {
				let urls = resolve({ path: `/onlyoffices/docview/${row.id}/1` });
				window.open(urls.href, '_blank');
			} else {
			}
		} else {
			unref(pdfViewRef)?.openDialog(row);
		}
	},
	/* 修改文件 */
	editors: (row: any) => {
		let urls = resolve({ path: `/onlyoffices/doceditor/${row.id}/1` });
		window.open(urls.href, '_blank');
	},
	/* 删除某个附件 */
	deleteFile: (row: any) => {
		const rowIndex = findIndex<any>(tableObject.tableList, (t: any) => {
			return t.id == row.id;
		});

		if (rowIndex < 0) return;

		const delData = {
			id: row.id,
			revision: row.revision,
		};

		ElMessageBox.confirm(t('material.message.deleteConfirm', '是否删除选中的数据？'), t('buttons.preview', '提示'), { confirmButtonText: t('buttons.submit', '确定'), cancelButtonText: t('buttons.cancel', '取消'), type: 'warning', lockScroll: false }).then(async () => {
			await DelMaterialsApi(delData).then((res) => {
				if (!res.succeeded) {
					ElMessage.error(`${t('material.message.deleteFailed', '附件删除失败，原因：')}${res.errors}`);
				} else {
					ElMessage.success(t('material.message.deleteSuccess', '删除成功。'));

					tableObject.tableList.splice(rowIndex, 1);
				}
			});
		});
	},
};

const upSchema = ref<any>({
	categroy_id: '0afff935-9ffa-4907-8ce8-a8bf3463b41e', // 固定这个分类
	ct_num: '',
	material_type: '',
	material_type_desc: '',
});

/* 上传组件设置 */
const uploads = {
	urls: `${base_url}/api/sysmaterial/uploadfile`,
	headers: {
		Authorization: '',
	},
	onUploadSuccess: (res: IResponse, file: any) => {
		if (!res.succeeded) {
			ElMessage.error(`${t('material.message.uploadFailed', '文件上传失败，可能的原因是：')}${res.errors}`);
		} else {
			ElMessage.success(t('material.message.uploadSuccess', '上传成功'));
			tableObject.tableList.push(res.data);
		}
	},
};

const changes = {
	materialtype: (val: any) => {
		unref(upSchema).material_type_desc = dicStore.getName('material_type', val) || '--';
	},
};

onMounted(() => {
	state.materialTypeList = dicStore.getSelectList('material_type');

	const defType = state.materialTypeList.filter((tp: any) => tp.label == '合同正本') || [];
	if (defType.length == 1) {
		unref(upSchema).material_type = defType[0].value;
		unref(upSchema).material_type_desc = defType[0].label;
	}

	const tokenStr = Session.get('token') as string;
	const token = (str: any) => {
		try {
			return JSON.parse(str);
		} catch (e) {
			return str;
		}
	};
	uploads.headers.Authorization = `Bearer ${token(tokenStr)}`;
});

const methods = {
	getFileList: () => {
		return tableObject.tableList.map((file: any) => file.id);
	},
	/* 获取合同关联附件记录 */
	setFileList: async (contractId: string) => {
		state.load = true;
		const { succeeded, errors, data } = await GetMaterialListApi(contractId);
		state.load = false;

		if (!succeeded) {
			ElMessage.error(`${t('material.message.loadMaterialListError', '读取付款计划列表数据出错，可能的原因是：')}${errors}`);
		} else {
			tableObject.tableList = data || [];
		}
	},
};

expose({ ...methods });

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_upload, {
        data: upSchema.value,
        action: uploads.urls,
        headers: uploads.headers,
        "show-file-list": false,
        "on-success": uploads.onUploadSuccess
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: upSchema.value.material_type,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((upSchema.value.material_type) = $event)),
            class: "mgr-10",
            style: {"width":"120px"},
            onChange: changes.materialtype
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).materialTypeList, (tps) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  label: tps.label,
                  value: tps.value
                }, null, 8, ["label", "value"]))
              }), 256))
            ]),
            _: 1
          }, 8, ["modelValue", "onChange"]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_button, { type: "primary" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('material.form.uploadAttachment', '上传附件')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["data", "action", "headers", "on-success"])
    ]),
    _createVNode(_unref(GbTables), {
      data: _unref(tableObject).tableList,
      columns: _unref(tabColumns),
      "show-paged": false,
      onRegister: _unref(register)
    }, {
      created_time: _withCtx(({ row }) => [
        _createTextVNode(_toDisplayString(_unref(fDateTime)(row.created_time)), 1)
      ]),
      material_type_desc: _withCtx(({ row }) => [
        _createVNode(_component_el_tag, {
          size: "small",
          type: "info"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(row.material_type_desc), 1)
          ]),
          _: 2
        }, 1024)
      ]),
      action: _withCtx(({ row }) => [
        _createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          link: "",
          onClick: ($event: any) => (actions.preview(row))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('billMaterialList.buttons.preview', '预 览')), 1)
          ]),
          _: 2
        }, 1032, ["onClick"]),
        (actions.showEdit(row))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              size: "small",
              type: "success",
              link: "",
              onClick: ($event: any) => (actions.editors(row))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('buttons.modify', '编 辑')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, {
          size: "small",
          type: "danger",
          link: "",
          onClick: ($event: any) => (actions.deleteFile(row))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('buttons.delete', '删 除')), 1)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      _: 1
    }, 8, ["data", "columns", "onRegister"]),
    _createVNode(PdfViewDialog, {
      ref_key: "pdfViewRef",
      ref: pdfViewRef
    }, null, 512)
  ], 64))
}
}

})